// extracted by mini-css-extract-plugin
export default {"confirmationWrapper":"CountdownEdit_confirmationWrapper__Y57oB","othersWrapper":"CountdownEdit_othersWrapper__05rHM","sendButtonAndTitle":"CountdownEdit_sendButtonAndTitle__w0Pwu"};